import { z } from 'zod';
import {
  ApplicationEvaluationOutcome,
  WSAutoApprovalStatus,
  WSEventType,
} from '~/enums';

export const wsAuthConfirmationSchema = z.object({
  action: z.literal('authorization'),
  responseCode: z.literal(200),
});

export const wsOfferMessageSchema = z.object({
  message: z.object({
    status: z.nativeEnum(WSAutoApprovalStatus).optional(),
    eventType: z.nativeEnum(WSEventType),
  }),
});

export const wsCardAutoApprovalMessageSchema = z.object({
  action: z.literal('message'),
  message: z.object({
    outcome: z.nativeEnum(ApplicationEvaluationOutcome),
    eventType: z.literal(WSEventType.CardAutoApproval),
  }),
});
